var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166748 13V10.6667H11.8334V13H0.166748ZM2.50008 8.33335H3.31675L7.86675 3.79794L7.0355 2.96669L2.50008 7.51669V8.33335ZM1.33341 9.50002V7.02085L7.86675 0.502104C7.97369 0.395159 8.09765 0.31252 8.23862 0.254187C8.3796 0.195854 8.52786 0.166687 8.68342 0.166687C8.83897 0.166687 8.98967 0.195854 9.1355 0.254187C9.28133 0.31252 9.41258 0.40002 9.52925 0.516687L10.3313 1.33335C10.448 1.4403 10.5331 1.56669 10.5865 1.71252C10.64 1.85835 10.6667 2.00905 10.6667 2.1646C10.6667 2.31044 10.64 2.45384 10.5865 2.59481C10.5331 2.73578 10.448 2.8646 10.3313 2.98127L3.81258 9.50002H1.33341Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.83e25f44.svg";
export { ForwardRef as ReactComponent };